import { render, staticRenderFns } from "./ApplicationsView.vue?vue&type=template&id=22d64c9e"
import script from "./ApplicationsView.vue?vue&type=script&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports